// header-mega-menu-fix.js
// Handles the header background color change when mega menu is open on desktop

document.addEventListener('DOMContentLoaded', function() {
  patchedInitMegaMenuHandler();
  
  // In case of dynamic section loads (Shopify)
  document.addEventListener('shopify:section:load', function() {
    patchedInitMegaMenuHandler();
  });
});

function initMegaMenuHandler() {
  // Only apply to desktop view (990px and above)
  if (window.matchMedia('(max-width: 989px)').matches) return;
  
  // Get all mega menu details elements
  const megaMenus = document.querySelectorAll('.mega-menu');
  const headerWrapper = document.querySelector('.header-wrapper');
  
  if (!megaMenus.length || !headerWrapper) return;
  
  // For each mega menu, add event listeners
  megaMenus.forEach(megaMenu => {
    // Check if we've already initialized this mega menu
    if (megaMenu.hasAttribute('data-mega-menu-initialized')) return;
    
    // Mark as initialized
    megaMenu.setAttribute('data-mega-menu-initialized', 'true');
    // Remove old toggle event logic that directly adds/removes the class
    // We'll rely on hover logic instead for desktop
  });
}

// --- Mega Menu Hover Logic for Desktop (Final: Only One Open, Instant Content Update) ---
function setupDesktopMegaMenuHover() {
  if (window.matchMedia('(max-width: 989px)').matches) return;

  const headerWrapper = document.querySelector('.header-wrapper');
  const megaMenus = document.querySelectorAll('.mega-menu');
  let hoverTimeout;

  // Helper to check if any menu/nav is hovered
  function isAnyMenuHovered() {
    return Array.from(megaMenus).some(details => {
      const summary = details.querySelector('summary.header__menu-item');
      const menuContent = details.querySelector('.mega-menu__content');
      return (summary && summary.matches(':hover')) || (menuContent && menuContent.matches(':hover'));
    });
  }

  // Helper to open ONLY the given menu instantly
  function openOnlyMenu(detailsToOpen) {
    megaMenus.forEach(details => {
      if (details === detailsToOpen) {
        if (!details.hasAttribute('open')) details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
    });
    if (headerWrapper) headerWrapper.classList.add('mega-menu--open');
  }

  // Helper to close all menus
  function closeAllMenus() {
    megaMenus.forEach(details => details.removeAttribute('open'));
    if (headerWrapper) headerWrapper.classList.remove('mega-menu--open');
  }

  megaMenus.forEach(details => {
    const summary = details.querySelector('summary.header__menu-item');
    const menuContent = details.querySelector('.mega-menu__content');
    if (!summary || !menuContent) return;

    // Mouse enter on summary or menu content: open menu, add class
    function handleEnter() {
      clearTimeout(hoverTimeout);
      openOnlyMenu(details);
      if (headerWrapper) headerWrapper.classList.add('mega-menu--open');
    }

    // Mouse leave: after short delay, check if ANY menu/nav is hovered, if not, close all and remove class
    function handleLeave() {
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(() => {
        if (!isAnyMenuHovered()) {
          closeAllMenus();
        }
      }, 150);
    }

    summary.addEventListener('mouseenter', handleEnter);
    summary.addEventListener('mouseleave', handleLeave);
    menuContent.addEventListener('mouseenter', handleEnter);
    menuContent.addEventListener('mouseleave', handleLeave);
    // Prevent click toggling
    summary.addEventListener('click', e => {
      e.preventDefault();
    });
  });
}

// Patch initMegaMenuHandler to call our hover logic
function patchedInitMegaMenuHandler() {
  initMegaMenuHandler();
  setupDesktopMegaMenuHover();
}

document.addEventListener('DOMContentLoaded', patchedInitMegaMenuHandler);
document.addEventListener('shopify:section:load', patchedInitMegaMenuHandler);